import { render, staticRenderFns } from "./video_detail.vue?vue&type=template&id=0f0f54b0&scoped=true"
import script from "./video_detail.vue?vue&type=script&lang=js"
export * from "./video_detail.vue?vue&type=script&lang=js"
import style0 from "./video_detail.vue?vue&type=style&index=0&id=0f0f54b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0f54b0",
  null
  
)

export default component.exports